const BOILERPLATE_SNIPPETS = [
  'Map',
  'Highlight this date',
  'Highlight all dates',
  'Link to this event',
  'Update this event',
  'If anything here is inaccurate',
];

const PROTECTED_TOKEN_RE = /(https?:\/\/\S+|www\.\S+|\S+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}|@[A-Za-z][\w.]*|\b[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*\.[a-z]{2,}\b)/g;

function decodeBasicEntities(value) {
  return String(value || '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>');
}

function htmlToPlainText(html = '') {
  if (typeof html !== 'string' || !html) return '';

  const withLineBreaks = html
    .replace(/\r\n?/g, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(?:div|h[1-6]|li|p|tr)>/gi, '\n')
    .replace(/<(?:div|h[1-6]|li|p|tr)(?:\s[^>]*)?>/gi, '\n')
    .replace(/<[^>]+>/g, ' ');

  return decodeBasicEntities(withLineBreaks).replace(/\u00a0/g, ' ');
}

function splitGluedWords(text) {
  let previous;
  let result = text;
  do {
    previous = result;
    result = result
      .replace(/([.!?])([A-Z][a-z])/g, '$1 $2')
      .replace(/(\))([A-Z])/g, '$1 $2')
      .replace(/([a-z]{2,})([A-Z][a-z])/g, '$1 $2')
      .replace(/([A-Z]{2,})([A-Z][a-z])/g, '$1 $2');
  } while (result !== previous);
  return result;
}

function insertMissingSpaces(text) {
  const ungluedUrls = text.replace(
    /(https?:\/\/\S*?(?:\/|\d))(?=[A-Z][a-z])/g,
    '$1 '
  );

  return ungluedUrls
    .split(PROTECTED_TOKEN_RE)
    .map((part, index) => {
      if (!part || index % 2 === 1) return part;
      return splitGluedWords(part);
    })
    .join('');
}

function isBoilerplateLine(line) {
  return BOILERPLATE_SNIPPETS.some((snippet) => line.includes(snippet));
}

function normalizeParagraphs(text) {
  return text
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function cleanDescription(description = '') {
  if (typeof description !== 'string' || !description) return '';

  const plain = insertMissingSpaces(htmlToPlainText(description));
  const withoutBoilerplate = plain
    .split('\n')
    .filter((line) => !isBoilerplateLine(line))
    .join('\n');

  return normalizeParagraphs(withoutBoilerplate);
}
